<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Product" | tenantWords}} Assemblies</h2>
      <span class="page-subtitle">Media recipes and their constituents</span>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="openEdit()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Create Assembly
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <div class="search-box">
      <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
      <input type="text" placeholder="Search by name, {{'product' | tenantWords}}, or instructions..."
        [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()" class="search-input" aria-label="Search assemblies">
    </div>
  </div>

  <div class="grid-card">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.rows" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings"
      [enableStickyHeader]="true" [enableHover]="true"
      (dataBound)="onDataBound()" (rowSelected)="onRowSelected($event)">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow" (click)="openEdit(row.assembly)">
      <div class="m-card-top">
        <span class="m-card-name">{{row.name || 'Unnamed assembly'}}</span>
        <ng-container *ngTemplateOutlet="countTemplate; context: { $implicit: row }"></ng-container>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="row.createdItemName">
          <fa-icon [icon]="faFlask" class="m-meta-icon"></fa-icon>{{row.createdItemName}}
        </div>
        <div class="m-meta-sub" *ngIf="row.description">{{row.description}}</div>
      </div>

      <div class="m-card-foot">
        <span class="m-card-note">Est. completed: {{(row.estCompletedQuantity | number) ?? '—'}}</span>
        <div class="m-card-actions">
          <button mat-icon-button aria-label="Edit assembly" (click)="openEdit(row.assembly); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faLayerGroup" class="m-empty-icon"></fa-icon>
      <div>No assemblies match your search</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #countTemplate let-data>
  <span class="type-pill" [class.empty]="!data.componentCount">
    {{data.componentCount}} {{data.componentCount === 1 ? 'constituent' : 'constituents'}}
  </span>
</ng-template>

<ng-template #actionTemplate let-data>
  <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
</ng-template>
